export default function SiteFooter() {
  const groups = [
    {
      title: "内容方向",
      links: [
        { label: "电影", href: "#overview" },
        { label: "电视剧", href: "#overview" },
        { label: "最新电影", href: "#movies" },
        { label: "热播剧", href: "#series" },
      ],
    },
    {
      title: "地区分类",
      links: [
        { label: "欧美大片", href: "#western" },
        { label: "国产剧", href: "#domestic" },
        { label: "华语电影", href: "#movies" },
        { label: "日韩动画", href: "#movies" },
      ],
    },
    {
      title: "浏览帮助",
      links: [
        { label: "选片指南", href: "#guide" },
        { label: "常见问题", href: "#faq" },
        { label: "筛选与搜索", href: "#movies" },
        { label: "回到顶部", href: "#top" },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">神马电影网</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-background-200/90 max-w-sm">
              一个把电影、电视剧、最新电影、热播剧、欧美大片与国产剧整理在一起的影视内容浏览页，
              帮助你在更短的时间里缩小查询范围，找到想看的方向。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-200/80">
              <i className="ri-information-line"></i>
              页面内容用于内容分类与浏览参考，具体信息请结合更多渠道综合判断。
            </div>
          </div>

          {groups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-primary-300 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200/90 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">© {new Date().getFullYear()} 神马电影网 · 影视内容浏览页</p>
          <p className="text-xs text-background-200/70">电影 · 电视剧 · 最新电影 · 热播剧 · 欧美大片 · 国产剧</p>
        </div>
      </div>
    </footer>
  );
}